import {ActionHandlerBase} from "../action-handler-base";
import {IOpenChallengesActionPayload} from "@sparkware/uc-sdk-core";
import {MyAccountTab} from "@sparkware/uc-sdk-core";

export class OpenChallengesActionHandler extends ActionHandlerBase<IOpenChallengesActionPayload> {
    async handle(payload: IOpenChallengesActionPayload): Promise<void> {
        await (await this.services.externalLinks).openMyAccount({
            tabId: MyAccountTab.LCChallenges
        });
    }

}